import { logger } from 'shared/lib'
import { UpgradePlanModalStore } from 'entities/Billing/ui/UpgradePlanModal'
import { type IResponseTollFree } from 'entities/Compliance'
import type { IResponseBillingComplianceInfo } from 'entities/Billing/api/types'
import { TrialLimitModalStore } from 'entities/Subscription/ui/TrialLimitModal'
import { TrialInboxesLimitModalStore } from 'entities/Subscription/ui/TrialInboxesLimitModal'
import { PaygLimitModalStore } from 'entities/Subscription/ui/PaygLimitModal'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import {
  GoToQuestionnaireModalStore,
  type IGoToQuestionnaireModalType,
} from 'pages/settings/pages/compliance/ui/GoToQuestionnaireModal'

export const publicApiReact = (entities: IEntitiesStore) => ({
  handleCheckInviteMembers() {
    new PaygLimitModalStore(entities).open('members')
  },
  openGoToQuestionnaireModal: (type: IGoToQuestionnaireModalType) => {
    if (!type) {
      return logger.error(
        "type: numbers | inboxes | members (example: openGoToQuestionnaireModal('members'))"
      )
    }

    new GoToQuestionnaireModalStore(entities).open(type)
  },

  openUpgradePlanModalFinishStore: (planId: string) => {
    if (!planId) {
      return logger.error(
        "planId: string (example: openUpgradePlanModalFinishStore('pro-yearly-3000'))"
      )
    }

    entities.subscriptionStore.init()
    new UpgradePlanModalStore(entities).openFinishModal(planId)
  },

  openTrialNumbersLimitModal: () => {
    new TrialLimitModalStore(entities).open('numbers')
  },

  openTrialInboxesLimitModal: () => {
    new TrialInboxesLimitModalStore(entities).open()
  },

  Compliance: {
    addTollFreeProfiles: (responseItems?: IResponseTollFree[]) => {
      if (!responseItems?.length) return

      entities.complianceStore.organizationTollFree?.addItems(responseItems)
    },

    addTollFreeProfile: (responseItem?: IResponseTollFree) => {
      if (!responseItem) return

      entities.complianceStore.organizationTollFree?.addItem(responseItem)
    },

    deleteTollFreeProfile: (id: number) => {
      entities.complianceStore.organizationTollFree?.deleteItem(id)
    },

    updateOrganizationVoiceIntegrity: () => {
      entities.complianceStore.complianceVoiceServicesStore.fetchComplianceVoiceServicesList()
    },

    updateOrganizationShakenStir: () => {
      entities.complianceStore.complianceVoiceServicesStore.fetchComplianceVoiceServicesList()
    },

    updateOrganizationCham: () => {
      entities.complianceStore.complianceVoiceServicesStore.fetchComplianceVoiceServicesList()
    },

    deleteCnamItem: () => {
      entities.complianceStore.complianceVoiceServicesStore.fetchComplianceVoiceServicesList()
    },
  },
  Billing: {
    updateBillingComplianceInfo: (response: IResponseBillingComplianceInfo) => {
      entities.billingStore.setBillingComplianceInfo(response)
    },
  },
  WebSocket: {
    reinit: entities.websocket.reinit,
  },
})
